




















































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import PembatalanSvc from "@/services/PembatalanKomponenDarah";
import { appModule } from "@/store/modules/app";
import {
  PembatalanFilter,
  PembatalanKomponenDarah,
  PembatalanStatus,
  STATUS_PEMBATALAN_WARNA
} from "@/types/pembatalan_komponen_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";

@Component({ components: { VCDateTimePicker, UnitRuangPicker } })
export default class PembatalanKomponenDarahPage extends Vue {
  filter: PembatalanFilter = {
    tgl_start: moment().subtract(7, "days").format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    unit_id: null,
    status: "",
    term: null
  };

  rows: PembatalanKomponenDarah[] = [];
  loading = false;
  prosesId: number | null = null;
  dialogTolak = false;
  tolakItem: PembatalanKomponenDarah | null = null;
  alasanTolak = "";

  readonly statusItems = [
    { text: "Semua", value: "" },
    { text: "Diajukan", value: "diajukan" },
    { text: "Disetujui", value: "disetujui" },
    { text: "Ditolak", value: "ditolak" }
  ];

  readonly headers = [
    { text: "Tgl Pembatalan", value: "dibatalkan_at", width: "120px" },
    { text: "Nama Pasien", value: "pasien_nama" },
    { text: "No RM", value: "pasien_rm", width: "90px" },
    { text: "Ruang", value: "ruang", sortable: false },
    { text: "Jenis Komponen", value: "komponen", sortable: false },
    { text: "Gol Darah", value: "golongan", sortable: false, width: "80px" },
    { text: "Detil No Kantong", value: "kantong", sortable: false },
    { text: "Pemohon", value: "pemohon_nama" },
    { text: "Status", value: "status", sortable: false },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "90px" }
  ];

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.muat();
  }

  warna(status: PembatalanStatus): string {
    return STATUS_PEMBATALAN_WARNA[status] || "blue-grey";
  }

  waktu(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
  }

  async muat() {
    this.loading = true;
    try {
      const res = await PembatalanSvc.list(this.filter);
      this.rows = res.rows;
    } catch {
      this.rows = [];
    } finally {
      this.loading = false;
    }
  }

  async terima(item: PembatalanKomponenDarah) {
    this.prosesId = item.id;
    try {
      const res = await PembatalanSvc.terima(item.id);
      appModule.sendSuccessNotice(res.message);
      this.muat();
    } catch {
      return;
    } finally {
      this.prosesId = null;
    }
  }

  bukaTolak(item: PembatalanKomponenDarah) {
    this.tolakItem = item;
    this.alasanTolak = "";
    this.dialogTolak = true;
  }

  async tolak() {
    if (!this.tolakItem || !this.alasanTolak.trim()) return;
    this.prosesId = this.tolakItem.id;
    try {
      const res = await PembatalanSvc.tolak(this.tolakItem.id, this.alasanTolak.trim());
      appModule.sendSuccessNotice(res.message);
      this.dialogTolak = false;
      this.muat();
    } catch {
      return;
    } finally {
      this.prosesId = null;
    }
  }
}
